export default __webpack_public_path__ + "static/media/PavathiLogo.15b4967b.svg";